import {
  Container,
  Grid,
  Menu,
} from 'semantic-ui-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';

import OnlinePayment from './OnlinePayments';
import OfflinePayment from './OfflinePayments';


import NavBar from '../../components/NavBar';
import { decodeSearch, encodeSearch } from '../../utils/url';

import { namespaces } from '../../constants/translation';

class Payments extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        onlinePaymentEnabled: PropTypes.bool,
      }),
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const { onlinePaymentEnabled = false } = props.appConfig.data;
    const TABS = [
      { value: 'payment', text: 'Payment', isShow: true },
      { value: 'online_payment', text: 'MHub Pay', isShow: onlinePaymentEnabled },
    ];
    const query = decodeSearch(props.location.search);
    const tabs = TABS.filter(e => e.isShow);
    const currentTab = tabs.some(t => t.value === query.tab) ? query.tab : tabs[0].value;

    return {
      currentTab,
      tabs,
    };
  }
  constructor(props) {
    super(props);
    const state = Payments.getPropsToState(props);
    state.data = [];
    this.state = {
      loading: true,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: '',
      },
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = Payments.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  replaceQuery(query) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  handleChangeTab = (e, { name }) => {
    const currentTab = name;
    this.replaceQuery({
      tab: currentTab,
    }, true);
    this.setState({
      currentTab,
      data: [],
      offset: 0,
      count: 0,
      limit: 0,
    });
  }
  render() {
    const { t } = this.props;
    const { currentTab, tabs } = this.state;
    const { onlinePaymentEnabled = false } = this.props.appConfig.data;
    return (
      <Container>
        <NavBar
          header={t('Payments')}
        />
        <Grid verticalAlign="middle">
          <Grid.Row className="tab-menu">
            <Grid.Column width={16}>
              <Menu
                attached="top"
                tabular
              >
                {
                  tabs.map((tab, key) => (
                    <Menu.Item
                      key={key}
                      name={tab.value}
                      onClick={this.handleChangeTab}
                      active={currentTab === tab.value}
                    >{(t(tab.text)).toUpperCase()}</Menu.Item>
                  ))
                }
              </Menu>
            </Grid.Column>
          </Grid.Row>
          {
            currentTab === 'payment' ? (
              <OfflinePayment
                location={this.props.location}
                auth={this.props.auth}
              />
            ) : null
          }
          {
            currentTab === 'online_payment' && onlinePaymentEnabled ? (
              <OnlinePayment
                location={this.props.location}
                auth={this.props.auth}
              />
            ) : null
          }
        </Grid>
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
])(connect(Payments.mapStateToProps)(Payments));



// WEBPACK FOOTER //
// ./src/containers/Payments/Payments.jsx